import produce from "immer";

const getDefaultState = () => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");
  if (token && user) {
    return JSON.parse(user);
  } else {
    return {};
  }
};

const user = (state = getDefaultState(), action) => {
  let nextState;
  switch (action.type) {
    case "USER_AUTH":
      localStorage.setItem("token", action.payload.data.jwt);
      localStorage.setItem("user", JSON.stringify(action.payload.data.user));
      nextState = produce(state, () => action.payload.data.user);
      return nextState;
    case "USER_ADD":
      return state;
    case "SCENARIO_ADD":
      nextState = produce(state, (draftState) => {
        draftState.scenarios.push(action.payload.data);
      });
      return nextState;
    case "SCENARIO_DELETE":
      nextState = produce(state, (draftState) => {
        draftState.scenarios = draftState.scenarios.filter(
          (scenario) => scenario.id !== action.payload.data.id
        );
      });
      return nextState;
    case "SCENARIO_TITLE_EDIT":
      nextState = produce(state, (draftState) => {
        draftState.scenarios.forEach((item) => {
          if (action.data.id === item.id) {
            item.name = action.data.value;
          }
        });
      });
      return nextState;
    case "USER_GET":
      if (action.payload.isAxiosError) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        nextState = {};
      } else {
        nextState = produce(state, () => action.payload.data);
      }
      return nextState;
    case "USER_SIGN_OUT":
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      nextState = produce(state, () => null);
      return nextState;
    default:
      return state;
  }
};

export default user;
